var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 3L1 1.25L9.75 1.25L9.75 3H10.625L10.625 1.25L10.6215 1.25219C10.6219 1.13736 10.5997 1.02358 10.5561 0.917339C10.5125 0.811103 10.4484 0.714496 10.3675 0.633035C10.2866 0.551575 10.1904 0.486858 10.0844 0.442584C9.97846 0.39831 9.86483 0.375344 9.75 0.375L1 0.375C0.767936 0.375 0.545376 0.467188 0.381282 0.631282C0.217188 0.795376 0.125 1.01794 0.125 1.25L0.125 3H1ZM9.75 8.25L9.13269 7.63531L5.8125 10.9516L5.8125 3H4.9375L4.9375 10.9516L1.61644 7.63531L1 8.25L5.375 12.625L9.75 8.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.dd5769886817d5f694985dbad9c7f1ad.svg";
export { ForwardRef as ReactComponent };